import _property from 'lodash/property';

var accountName = _property('accountName');

var accountNumber = _property('accountNumber');

var accountSubTypeId = _property('accountSubTypeId');

var accountTypeId = _property('accountTypeId');

var active = _property('active');

var balance = _property('balance');

var controlField = _property('controlField');

var controlFieldPattern = _property('controlFieldPattern');

var controlFieldType = _property('controlFieldType');

var controlType2 = _property('controlType2');

var createdByUserId = _property('createdByUserId');

var createdTime = _property('createdTime');

var dealerId = _property('dealerId');

var deleted = _property('deleted');

var departmentId = _property('departmentId');

var financialStatementGroupId = _property('financialStatementGroupId');

var financialStatementSubGroupId = _property('financialStatementSubGroupId');

var franchiseId = _property('franchiseId');

var id = _property('id');

var modifiedByUserId = _property('modifiedByUserId');

var modifiedTime = _property('modifiedTime');

var postingDescriptionRequired = _property('postingDescriptionRequired');

var statisticalCountType = _property('statisticalCountType');

var unitAnalysisGroupId = _property('unitAnalysisGroupId');

var controlNumberMandatory = _property('controlNumberMandatory');

var count = _property('count');

var control2Mandatory = _property('control2Mandatory');

var departmentType = _property('departmentType');

var enablePostingLineCountAdjustment = _property('enablePostingLineCountAdjustment');

var glAccountMetaData = _property('glAccountMetaData');

var countLogicEnabled = _property('countLogicEnabled');

var glAccountControlTypes = _property('glAccountControlTypes');

var primaryControlType = _property('primaryControlType');

var languages = _property('languages');

var READER = {
  accountName: accountName,
  accountNumber: accountNumber,
  accountSubTypeId: accountSubTypeId,
  accountTypeId: accountTypeId,
  active: active,
  balance: balance,
  controlField: controlField,
  controlFieldPattern: controlFieldPattern,
  controlFieldType: controlFieldType,
  controlType2: controlType2,
  createdByUserId: createdByUserId,
  createdTime: createdTime,
  dealerId: dealerId,
  deleted: deleted,
  departmentId: departmentId,
  financialStatementGroupId: financialStatementGroupId,
  financialStatementSubGroupId: financialStatementSubGroupId,
  franchiseId: franchiseId,
  id: id,
  modifiedByUserId: modifiedByUserId,
  modifiedTime: modifiedTime,
  postingDescriptionRequired: postingDescriptionRequired,
  statisticalCountType: statisticalCountType,
  unitAnalysisGroupId: unitAnalysisGroupId,
  controlNumberMandatory: controlNumberMandatory,
  count: count,
  control2Mandatory: control2Mandatory,
  departmentType: departmentType,
  enablePostingLineCountAdjustment: enablePostingLineCountAdjustment,
  glAccountMetaData: glAccountMetaData,
  countLogicEnabled: countLogicEnabled,
  glAccountControlTypes: glAccountControlTypes,
  primaryControlType: primaryControlType,
  languages: languages
};
export default READER;